import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';
import { post } from 'app/shared/utils/fetchr';

type CompleteMcpOAuthPayload = {
  state: string;
  approved: boolean;
};

type CompleteMcpOAuthResponse = {
  redirect_url: string;
};

const completeMcpOAuth = (payload: CompleteMcpOAuthPayload) =>
  post<CompleteMcpOAuthResponse>('/v1/mcp/oauth/complete', payload);

export const useCompleteMcpOAuth = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: completeMcpOAuth,
    onSuccess: (_, { approved }) => {
      dispatch(
        sendSuccessToast(
          approved
            ? 'MCP connection approved.'
            : 'MCP connection request denied.',
        ),
      );
    },
    onError: () => {
      dispatch(
        sendErrorToast(
          'Unable to complete MCP authorization. Please try again.',
        ),
      );
    },
  });
};
